import React, { useEffect, useState } from "react";
import "./IFSC_Modification.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form } from "react-bootstrap";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SubmitIFSCModification } from "../../features/support/slice";
import { GetAllBanks } from "../../features/wallet/slice";
import Select from "react-select";

function IFSC_Modification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const {
    register,
    handleSubmit,
    reset, control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      ifsc_code: "",
      bank_number: "",
    },
  });

  const onSubmit = async (data) => {
    try {

      const res = await dispatch(SubmitIFSCModification({
        ifsc_code: data.ifsc_code.trim(),
        bank_number: data.bank_id?.account_number,
        bank_id: data.bank_id?.value,
      }));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data);
        setModalShow(true);
        reset();
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }

    } catch (error) {
      console.error("IFSC Modification Error:", error);
    }
  };

  const allBanks = useSelector((state) => state.wallet.banks);

  useEffect(() => {
    dispatch(GetAllBanks({}));
  }, [dispatch,]);

  return (
    <>
      <section className="Change_Login_Password login-page">
        <Common_white_header headingText={"IFSC Modification"} />

        <div className="container">
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* ── Correct IFSC Code ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Select Bank <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Controller
                name="bank_id"
                control={control}
                rules={{ required: "Bank is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={allBanks?.map((bank) => ({
                      value: bank?.id,
                      label: `${bank?.bank_name} - ${bank?.account_number}`,
                      account_number: bank?.account_number,
                    }))}

                  />
                )}
              />
              {errors.bank_id && (
                <small className="text-danger">{errors.bank_id.message}</small>
              )}
            </Form.Group>
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Correct IFSC Code <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Correct IFSC Code"
                {...register("ifsc_code", {
                  required: "IFSC Code is required",
                  pattern: {
                    value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: "Enter a valid IFSC Code (e.g. SBIN0001234)",
                  },
                })}
              />
              {errors.ifsc_code && (
                <small className="text-danger">{errors.ifsc_code.message}</small>
              )}
            </Form.Group>

            {/* <Form.Group className="form-group field_holder">
              <Form.Label>
                Bank Account Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Bank Card Number"
                {...register("bank_number", {
                  required: "Bank account number is required",
                  minLength: { value: 9, message: "Minimum 9 digits required" },
                  maxLength: { value: 18, message: "Maximum 18 digits allowed" },
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Bank account number must contain only digits",
                  },
                })}
              />
              {errors.bank_number && (
                <small className="text-danger">{errors.bank_number.message}</small>
              )}
            </Form.Group> */}

            {/* ── Submit ── */}
            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </div>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default IFSC_Modification;